import axios from "axios";
import { API_BASE_URL, getAuthConfig } from "./apiClient";

export const fetchAboutUs = async () => {
  const response = await axios.get(`${API_BASE_URL}/about-us`);
  return response.data;
};

export const addAboutUs = async (payload) => {
  const response = await axios.post(
    `${API_BASE_URL}/about-us`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const updateAboutUs = async (payload) => {
  const response = await axios.put(
    `${API_BASE_URL}/about-us`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const uploadAboutUs = async (payload) => {
  const response = await axios.post(
    `${API_BASE_URL}/about-us/upload`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};
